var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMounted)?_c('div',{attrs:{"tabindex":"-1"}}):_vm._e(),_c('div',{staticClass:"map-html-overlays"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }